var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M0 0h53.3v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 28h53.3v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m19.5 31.9.5.2L31.6 12q.9-.4 1.5-1.5c.2-.4 1.2-2.2 1.6-4.4q-1.6 1.6-3 3.7-.6 1-.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.5 31.9.5.2L31.6 12q.9-.4 1.5-1.5c.2-.4 1.2-2.2 1.6-4.4q-1.6 1.6-3 3.7-.6 1-.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m33.8 31.9-.4.2L21.7 12q-1-.4-1.4-1.5C20 10 19 8.2 18.6 6q1.8 1.6 3 3.7.6 1 .5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.8 31.9-.4.2L21.7 12q-1-.4-1.4-1.5C20 10 19 8.2 18.6 6q1.8 1.6 3 3.7.6 1 .5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    d: "M53.4 14h-22c-.7-2-3.2-6-4.7-6s-4 4-4.8 6H0v12h22c.8 2 3.3 6 4.8 6s4-4 4.7-6h22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.4 26q1.2-3 1.3-6 0-3-1.3-6-1.1 3-1.2 6t1.2 6M22 26q-1.2-3-1.3-6 0-3 1.2-6 1.2 3 1.3 6 0 3-1.3 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.7 21.5q.9-.1 1-1.5-.1-1.4-1-1.5-1 .1-1 1.5t1 1.5m.3 0s1 2 1 5.2-1 5.3-1 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.4 18.6s-1-2-1-5.3 1-5.2 1-5.2zm0 2.9s-1 2-1 5.2 1 5.3 1 5.3zm.6-2.9s1-2 1-5.3-1-5.2-1-5.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/ke.a9467572c9105b56868ec93b765d1004.svg";
export { ForwardRef as ReactComponent };